import React from 'react';
import { useStreamChat } from '../../context/StreamChatContext';

const UserStatusIndicator = ({ userId, showText = false, size = 'sm' }) => {
  const { getUserOnlineStatus } = useStreamChat();
  
  if (!userId) return null;
  
  const { online, lastSeen } = getUserOnlineStatus(userId);
  
  const sizeClasses = {
    xs: 'w-2 h-2',
    sm: 'w-3 h-3', 
    md: 'w-4 h-4',
    lg: 'w-5 h-5'
  };
  
  const getLastSeenText = () => {
    if (!lastSeen) return 'Last seen unknown';
    
    const now = new Date();
    const diffMs = now - lastSeen;
    const diffMins = Math.floor(diffMs / (1000 * 60));
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    
    if (diffMins < 1) return 'Last seen just now';
    if (diffMins < 60) return `Last seen ${diffMins}m ago`;
    if (diffHours < 24) return `Last seen ${diffHours}h ago`;
    if (diffDays < 7) return `Last seen ${diffDays}d ago`;
    return `Last seen ${lastSeen.toLocaleDateString()}`;
  };
  
  return (
    <div className="flex items-center">
      <div 
        className={`${sizeClasses[size]} rounded-full border-2 border-white ${
          online ? 'bg-green-500' : 'bg-gray-400'
        }`}
        title={online ? 'Online' : getLastSeenText()}
      />
      {showText && (
        <span className={`ml-2 text-xs ${
          online ? 'text-green-600' : 'text-gray-500'
        }`}>
          {online ? 'Online' : getLastSeenText()}
        </span>
      )}
    </div>
  );
};

export default UserStatusIndicator;